import { bigToCrypto, uiCryptoDecimals } from '../utils'

import NumberFormat from './NumberFormat'

const CryptoNumber = ({ decimals = uiCryptoDecimals, ...props }) => (
  <NumberFormat
    decimals={decimals}
    minimumValuePrefix={`${props.prefix ? `${props.prefix.trimEnd()} ` : ''}< `}
    round={value => bigToCrypto(value)}
    {...props}
  />
)

export default CryptoNumber
